module.exports = __webpack_public_path__ + "static/media/diary-2.982f3d81.png";